
import React from "react";
import { CalendarCheck, Video, FileText } from "lucide-react";

const steps = [
  {
    step: 1,
    title: "Book Your Session",
    description: "Choose your consultation type and select an available time slot that works for your schedule.",
    icon: CalendarCheck
  },
  {
    step: 2,
    title: "Join Your Video Call",
    description: "Connect with your expert advisor via video call. You'll receive a Google Meet link in your confirmation email.",
    icon: Video
  },
  {
    step: 3,
    title: "Get Your Action Plan",
    description: "Receive a personalized action plan with next steps, resources, and ongoing support recommendations.",
    icon: FileText
  }
];

export function HowItWorks() {
  return (
    <section className="py-16 bg-grandpal-green-light">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Getting expert guidance is simple. Follow these three easy steps to book 
            and attend your consultation.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-grandpal-green rounded-full flex items-center justify-center mx-auto mb-4">
                  <step.icon className="h-8 w-8 text-white" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full flex items-center justify-center text-grandpal-green font-bold text-lg border-2 border-grandpal-green">
                  {step.step}
                </div>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
